
export interface SRTBlock {
  id: number;
  startTime: string;
  endTime: string;
  text: string;
  originalText: string;
  isManuallyEdited?: boolean; // Đánh dấu nếu người dùng sửa tay
  feedbackStatus?: 'none' | 'like' | 'dislike'; // Trạng thái đánh giá
  isRetranslating?: boolean; // Trạng thái đang dịch lại dòng này
  isReadOnly?: boolean; // Đánh dấu dòng không được phép chỉnh sửa (VD: Chữ ký)
}

export enum ToneLevel {
  Polite = 1,
  Standard = 2,
  Casual = 3,
  Street = 4,
  Profane = 5,
}

export enum AppStatus {
  Idle = 'idle',
  Parsing = 'parsing',
  Translating = 'translating',
  Completed = 'completed',
  Error = 'error',
}

export type ApiConnectionStatus = 'unknown' | 'verifying' | 'valid' | 'invalid';

export interface MovieContext {
  title: string;
  plot: string;
}

export interface TranslationStats {
  totalBlocks: number;
  translatedBlocks: number;
  errors: number;
  startTime: number | null;
  estimatedTimeRemaining: number | null; // seconds
}

export const SUPPORTED_MODELS = [
  { id: 'gemini-3-pro-preview', name: 'Gemini 3 Pro (Preview)' },
  { id: 'gemini-3-flash-preview', name: 'Gemini 3 Flash (Preview)' },
  { id: 'gemini-2.5-pro', name: 'Gemini 2.5 Pro' },
  { id: 'gemini-2.5-flash', name: 'Gemini 2.5 Flash' },
  { id: 'gemini-2.5-flash-lite', name: 'Gemini 2.5 Flash Lite' },
];
